import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, LayoutGrid, Search, ShoppingBag, User } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";
import { sectionFlag } from "@/lib/useTemplateSections";

export const MobileNav = ({ onSearch, sections, loaded = true }) => {
  const { count, setOpen } = useCart();
  const { user } = useAuth();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const showSearch = sectionFlag(sections, "header_menu", "show_search", true, loaded);
  const showCart = sectionFlag(sections, "header_menu", "show_cart", true, loaded);
  const showAccount = sectionFlag(sections, "header_menu", "show_account", true, loaded);
  // defaultValue=false : menu affiché tant que la boutique ne l'a pas
  // explicitement désactivé (comportement d'origine inchangé) — y compris
  // pendant le chargement, sectionFlag(..., loaded=false) renvoyant false.
  const hideNav = sectionFlag(sections, "header_menu", "hide_mobile_bottom_nav", false, loaded);

  if (hideNav) return null;

  const item = "flex flex-col items-center justify-center gap-1 flex-1 h-full text-[10px] uppercase tracking-wider font-sans transition-colors";
  const active = (p) => (pathname === p ? "text-ink" : "text-ash");

  return (
    <nav
      data-testid="mobile-bottom-nav"
      className="fixed bottom-0 z-40 w-full bg-cream/95 backdrop-blur-xl border-t border-stone/60 md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="h-16 flex items-center justify-around">
        <Link to="/" data-testid="bottomnav-home" className={`${item} ${active("/")}`}>
          <Home className="h-5 w-5" strokeWidth={1.5} />
          Accueil
        </Link>
        <Link to="/boutique" data-testid="bottomnav-shop" className={`${item} ${active("/boutique")}`}>
          <LayoutGrid className="h-5 w-5" strokeWidth={1.5} />
          Boutique
        </Link>
        {showSearch && (
          <button data-testid="bottomnav-search" onClick={onSearch} className={`${item} text-ash`}>
            <Search className="h-5 w-5" strokeWidth={1.5} />
            Recherche
          </button>
        )}
        {showCart && (
          <button data-testid="bottomnav-cart" onClick={() => setOpen(true)} className={`${item} text-ash relative`}>
            <span className="relative">
              <ShoppingBag className="h-5 w-5" strokeWidth={1.5} />
              {count > 0 && (
                <span className="absolute -top-2 -right-2 bg-ink text-cream text-[9px] font-mono h-4 w-4 flex items-center justify-center rounded-full">
                  {count}
                </span>
              )}
            </span>
            Panier
          </button>
        )}
        {showAccount && (
          <button
            data-testid="bottomnav-account"
            onClick={() => navigate(user ? "/compte" : "/connexion")}
            className={`${item} ${active("/compte")}`}
          >
            <User className="h-5 w-5" strokeWidth={1.5} />
            Compte
          </button>
        )}
      </div>
    </nav>
  );
};
